import React from 'react'
const regex = /^\(?([0-9]{3})\)([0-9]{3})[-. ]?([0-9]{4})$/

type Props = {
  children: string | string[] | undefined | null
}

export const PhoneNumber = ({ children }: Props) => {
  if (Array.isArray(children)) {
    return (
      <>
        {children.map((child) => (
          <PhoneNumber key={child}>{child}</PhoneNumber>
        ))}
      </>
    )
  }
  const txt = regex.test(children || '') ? children?.replace(')', ') ') : children
  return <>{txt}</>
}
